<template>
  <b-card>

    <!-- Alert: No item found -->
    <b-alert variant="danger" :show="calendarData === undefined">
      <h4 class="alert-heading">
       {{ $t('Error fetching calendar data')}}
      </h4>
      <div class="alert-body">
        {{ $t('No calendar found with this calendar id. Check')}}
        <b-link class="alert-link" :to="{ name: 'calendar_index'}">
          {{ $t('Calendars List')}}
        </b-link>
        {{ $t('for other calendars.')}}
      </div>
    </b-alert>

    <div class="loading_page" v-if="requestStatus">
      <orbit-spinner
          :animation-duration="1000"
          :size="100"
          :color="'#0e96b1'"
      />
    </div>

    <div>

      <!-- Name -->
      <b-form-group :label="$t('Name')" label-for="name">
        <b-form-input
            id="name"
            v-model="calendarData.name"
            autofocus
            :state="errors && ('name' in errors) ? false : null"
            trim
            autocomplete="off"
            :placeholder="$t('Name')"
        />

        <b-form-invalid-feedback :state="errors && ('name' in errors) ? false : null">
          {{ errors && ('name' in errors) ? $t(errors.name[0]) : null }}
        </b-form-invalid-feedback>

      </b-form-group>


      <!-- ics file -->
      <b-form-group :label="$t('Calendar File')" label-for="file">
        <b-form-file
            ref="refInputEl"
            accept=".ics"
            id="file"
            autofocus
            @input="inputImageRenderer"
            :state="errors && ('data' in errors) ? false : null"
            trim
        />

        <b-form-invalid-feedback :state="errors && ('data' in errors) ? false: null">
          {{ errors && ('data' in errors) ? errors.data[0] : null }}
        </b-form-invalid-feedback>

      </b-form-group>

      <!-- Form Actions -->
      <div class="d-flex mt-2">
        <b-button ref="dfghdfgh"
            variant="primary"
            class="mr-2"
            @click="submit"
            type="submit">
          {{ $t('Save')}}
        </b-button>
      </div>
    </div>


  </b-card>
</template>

<script>
import {
  BTab, BTabs, BCard, BAlert, BLink, BButton, BFormGroup, BFormInput, BForm, BFormTextarea,
  BFormInvalidFeedback, BFormFile
} from 'bootstrap-vue'
import { onMounted, onUnmounted, ref } from '@vue/composition-api'
import store from '@/store'
import calendarStoreModule from '@/views/modules/calendar/calendarStoreModule'

import { OrbitSpinner } from 'epic-spinners'
import useCalendarEdit from '@/views/modules/calendar/calendar-edit/useCalendarEdit'
import vSelect from 'vue-select'
import { useInputImageRenderer } from '@core/comp-functions/forms/form-utils'

export default {
  components: {
    BTab,
    BTabs,
    BFormTextarea,
    BFormInvalidFeedback,
    vSelect,
    BCard,
    BButton,
    BFormGroup,
    BFormInput,
    BForm,
    BAlert,
    BFormFile,
    OrbitSpinner,
    BLink,

  },
  setup(props, { root }) {

    const refInputEl = ref(null)

    const CALENDAR_APP_STORE_MODULE_NAME = 'app-calendar'

    if (!store.hasModule(CALENDAR_APP_STORE_MODULE_NAME)) store.registerModule(CALENDAR_APP_STORE_MODULE_NAME, calendarStoreModule)

    onUnmounted(() => {
      if (store.hasModule(CALENDAR_APP_STORE_MODULE_NAME)) store.unregisterModule(CALENDAR_APP_STORE_MODULE_NAME)
    })

    const { submit, requestStatus, errors, fetchCalendar, calendarData } = useCalendarEdit(root)

    const { inputImageRenderer } = useInputImageRenderer(refInputEl, base64 => {
      calendarData.value.data = base64.split(',')[1]
    })

    fetchCalendar()

    return {
      calendarData,
      fetchCalendar,
      requestStatus,
      errors,
      submit,
      inputImageRenderer,
      refInputEl
    }

  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
#add-new-type-sidebar {
  .vs__dropdown-menu {
    max-height: 200px !important;
  }
}
</style>
